module.exports = __webpack_public_path__ + "static/feature-channel-f5675bceb406ffc24c1a418351610a76.png";